<template>
  <div id="app">
    <div id="tTTopEmpty" @click="onEmptyClick()"></div>
    <div id="tTMainContent" :style="{height:contentHeight}">
      <TabBar id="tTmenu"></TabBar>
      <div id="tTcontent">
        <KeepAlive>
          <router-view></router-view>
        </KeepAlive>
      </div>
      <TouTiaoLoading v-if="$store.state.showLoading"/>
      <Toast v-if="$store.state.showToast"/>
    </div>
    <AlertWxBind v-if="$store.state.showWxBindPage"/>
  </div>
</template>

<script>

import TouTiaoLoading from "views/loading/TouTiaoLoading.vue";
import Toast from "views/alert/Toast.vue";
import utils from './utils';
import { request } from './network/request';
import getRequestParams from "./signParams";
import Vue from 'vue';
import urls from 'network/urls';
import urlsv2 from 'network/urlsv2';
import TabBar from "views/TouTiaoApp/TabBar.vue";

import AlertWxBind from 'views/alert/AlertWxBind.vue';

export default {
  name: 'App',
  data () {
     return {
      contentHeight: '55vh',
      timer: null
     }
   },
  components:{
    TouTiaoLoading,
    Toast,
    TabBar,
    AlertWxBind
  },
  mounted:function(){ 
    // 获取url中的param=后面的参数值，在这里携带的是{"key":"value"}的json形式
    let params = utils.getUrlKey("param")
    // 将获取到的参数更新到store中，方面后续获取公共参数
    this.$store.commit('updateCommonParams', params)
    
    // 判斷是哪個版本的紅包
    let rebatev2 = this.$store.state.commonParameters['rebatev2']
    if (rebatev2 === 'true') {// 使用红包版本v2的api
      Vue.prototype.urls = urlsv2
    }else{
      Vue.prototype.urls = urls
    }
    // 从store获取公共参数,这些参数是在一开始就获取到的
    let storeCommomParams = this.$store.getters.getCommomParams;
    // 使用公共参数转换成用于请求api需要的参数值形式
    let signParams = getRequestParams({},storeCommomParams);
    // 先去获取rid，phone，更新到基本参数中去，再去请求红包初始化，红包用户信息
    request({
      url:this.urls.REBATE_INFO,
      params: {
        data: signParams // 在url后面加上&data=[signParams具体内容]
      },
    }).then(res =>{
      // 更新公共参数中的rid和phone，不直接从原始公共参数中传递。是为了避免直接暴露rid
      this.$store.dispatch("networkUpdateRid",{"rid": res["rid"], "phone": res["phone"]})
      signParams = getRequestParams({},storeCommomParams);
      let rebateInitReq = request({
      url:this.urls.REBATE_INIT,
      params: {
        data: signParams
        },
      })
      let rebateUser = request({
        url:this.urls.REBATE_USER,
        params: {
          data: signParams
        },
      })
      // 将红包初始化，和红包用户接口两个请求合并，当两个请求都成功才处理then里面的内容
      Promise.all([rebateInitReq, rebateUser]).then(values => {
        console.log(values);
        // 网络请求异步的数据，需要用 dispatch
        let payload = {"initData": values[0], "userInfoData": values[1]}
        this.$store.dispatch('networkHandleRebateAndUserInitV2', payload)

        // document.querySelector('body').setAttribute('style', 'background-color:#0505056f;')
      

      })
    })
    // 通知安卓端，H5已经准备好，可以发送需要数据过来了，目前只要客服未读信息
    this.sendToClient('sdkFinish?')
    setTimeout(() => {
      // document.querySelector('#tTTopEmpty').setAttribute('style', 'background-color:#000;opacity:0.5')
      const deTime = 2;
      const TIME_COUNT = 50;
      // alpha值需要最终显示0.5 ，然后在 TIME_COUNT 毫秒内，每 deTime 时间变一次，这里的 splitTime 是每 deTime 变一次需要加上的值
      const splitTime = 0.5 / (TIME_COUNT/deTime);
      let count = TIME_COUNT;
      let opacity = 0;
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (count > 0 && count <= TIME_COUNT) {
            count-=deTime;
            opacity += splitTime;
            let opacityValue = 'background-color:#000;opacity:'+opacity
            // console.log(opacityValue);
            document.querySelector('#tTTopEmpty').setAttribute('style', opacityValue)
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, deTime)
      }
    }, 240);
    
    // 是否是横屏,修改高度，方便滑動
    // if (storeCommomParams['landGame'] === 'true') {
    //   this.contentHeight = "85vh"
    // }
  }, 
  // mounted:function(){

  // },
  methods:{
    setWxBindCallback(){
      // console.log("点击绑定微信");
      let storeCommomParams = this.$store.getters.getCommomParams;
      // 这里显示绑定提取方式  ct=rebate&ac=wxAuth  获取微信绑定二维码展示
      let wxBindReqParams = getRequestParams({},storeCommomParams);
      request({
        url:this.urls.REBATE_WXAUTH,
        params: {
          data: wxBindReqParams
        },
      }).then(res =>{
        // console.log(res);
        // console.log(JSON.parse(res.param)['url']);
        if("qrcode" == res.type){
          let qrcodeUrl = JSON.parse(res.param)['url'];
          this.$store.dispatch('networkWxBindPageShow', {"showOrHide":true, "qrcodeUrl": qrcodeUrl})
        }else{
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "暂无绑定方式"})
          this.$store.dispatch('networkWxBindPageShow', {"showOrHide":false, "qrcodeUrl": ""})
        }
      })
    },
    // 点击空白页，让安卓端红包中心页面消失
    onEmptyClick(){
      this.sendToClient('close?')
    }
  }
}
</script>

<style>

  body{
    padding-top: 0%;
    margin: 0%;
  }


  #tTTopEmpty{
    width: 100vw;
    height: 45vh;
    /* background: transparent; */
    /* background-color: #0505056f; */
    /* background-color: #00000000; */

    /* opacity:0.5;
    filter:alpha(opacity=0);
    background:#fff; */

  }
  #tTMainContent{
    width: 100vw;
    height: 55vh;
    background-color: #F6F6F6;
  }
  #tTmenu{
    position: fixed;
    width: 15vw;
    height: 100%;
    background-color: #FFF3F3;
  }
  #tTcontent{
    /* width: 80%; 用百分比的话，会在安卓端WebView加载后，整个界面左右上下滑动出一点空白，不好看。使用vw可以避免这种情况 */
    width: 85vw;
    height: 55vh;
    /* height: 100%; */
    /* overflow-y:auto; */
    float: right;
    display: flex;
    flex-flow: column;
  }

</style>



// WEBPACK FOOTER //
// src/TouTiaoApp.vue